import React from "react";
import T from "prop-types";

import useZadostiGroups from "b2b/api/hooks/useZadostiGroups";

import mapStavToType from "./constants/mapStavToType";
import ZadostiGroupsContent from "./ZadostiGroupsContent";

export function ZadostiGroups({
  datumOd,
  datumDo,
  messageEmpty,
  onChange,
  value,
  showAll,
  stav
}) {
  const loader = useZadostiGroups({
    datumOd: datumOd,
    datumDo: datumDo,
    stav
  });
  return (
    <ZadostiGroupsContent
      {...loader}
      messageEmpty={messageEmpty}
      onChange={onChange}
      value={value}
      showAll={showAll}
      type={mapStavToType[stav]}
    />
  );
}

ZadostiGroups.propTypes = {
  datumOd: T.instanceOf(Date),
  datumDo: T.instanceOf(Date),
  messageEmpty: T.string,
  onChange: T.func.isRequired,
  value: T.object,
  showAll: T.bool,
  stav: T.string
};

export default React.memo(ZadostiGroups);
